module.exports = __webpack_public_path__ + "img/name.57ec89e1.png";